import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";
import { formatTime } from "../../../helpers/generalHelpers";
import { downloadSummaryCsv } from "./resultsSummaryDownload";

const PAGE_SIZE = 10;

export default function SelectedLinkAgentsTable({ rows, selectedTime, runId }) {
  const [page, setPage] = useState(0);
  useEffect(() => setPage(0), [rows]);
  const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const visible = rows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return <div className="mb-results-agents">
    <div className="mb-results-agentsHeader">
      <div className="mb-results-agentsHeaderInfo">
        <strong>{rows.length.toLocaleString()} agents on selected links</strong>
        <span>At {formatTime(selectedTime, { style: "digital" })}</span>
      </div>
      {!!rows.length && <div className="mb-results-summaryDownload"><button type="button" aria-label="Download all agents as CSV" title="Download CSV" onClick={() => downloadSummaryCsv(`agents-on-selected-links-${runId}-${selectedTime}.csv`, rows.map((row) => ({ agent_id: row.agent_id, agent_status: row.agent_status, link_id: row.link_id })))}><Download size={17} /></button></div>}
    </div>
    {!rows.length ? <p className="mb-results-summaryMessage">No agents are on the selected links at this time.</p> : <>
      <div className="mb-results-agentsTableWrap"><table className="mb-results-agentsTable">
        <thead><tr><th scope="col">Agent ID</th><th scope="col">Status</th><th scope="col">Link ID</th></tr></thead>
        <tbody>{visible.map((row, index) => <tr key={`${row.agent_id}:${row.link_id}:${page * PAGE_SIZE + index}`}>
          <td>{row.agent_id}</td><td>{row.agent_status || "—"}</td><td>{row.link_id}</td>
        </tr>)}</tbody>
      </table></div>
      {totalPages > 1 && <div className="mb-results-agentsPagination">
        <button type="button" aria-label="Previous page" title="Previous page" disabled={page === 0} onClick={() => setPage((current) => current - 1)}><ChevronLeft size={17} /></button>
        <span>{page + 1} of {totalPages}</span>
        <button type="button" aria-label="Next page" title="Next page" disabled={page + 1 >= totalPages} onClick={() => setPage((current) => current + 1)}><ChevronRight size={17} /></button>
      </div>}
    </>}
  </div>;
}
